import useAxios from "@/compositions/useAxios";
import type { AxiosRequestConfig } from "axios";

const METERING_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/metering/api/v1/metering/`;

const { get, post } = useAxios(METERING_BASE_URL);

const withApiKey = (config?: AxiosRequestConfig): AxiosRequestConfig => ({
  ...config,
  headers: { ...config?.headers, "api-key": import.meta.env.VITE_TENANT_API_KEY }
});

const meteringCrudFactory = (endpoint: string) => ({
  getAll: <T>(config?: AxiosRequestConfig): Promise<T> => get<T>(endpoint, withApiKey(config)),
  createOne: <T>(data: unknown, config?: AxiosRequestConfig): Promise<T> => post<T>(endpoint, data, withApiKey(config))
});

export default meteringCrudFactory;
